import { Routes } from '@angular/router';
import { RekensprintRouterEnum } from './infrastructure/enums/router-link.enum';
import { RouterAuthEnum } from 'projects/shared/src/lib/infrastructure/enums/router-link.enum';
import { RouterCommonPagesEnum } from 'projects/shared/src/lib/infrastructure/enums/common-pages.enum';
import { CanDeactivateGuard } from 'projects/shared/src/lib/core/guards/can-deactivate.guard';
import { CanActivateUser } from 'projects/shared/src/lib/core/guards/url-allowed.guard';
import { ProjectName } from 'projects/shared/src/lib/core/enums/project-name.enum';
import { taskResultResolver } from './infrastructure/resolvers/task-result.resolver';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/practice/practice.component').then((m) => m.PracticeComponent),

    canActivate: [CanActivateUser],
    data: {
      // data for canActivateAdmin
      project: ProjectName.Rekensprint,
    },
  },
  {
    path: RekensprintRouterEnum.KitchenSink,
    pathMatch: 'full',
    loadComponent: () =>
      import('../../../shared/src/kichensink/kitchensink.component').then(
        (m) => m.KitchensinkComponent
      ),
  },
  // TODO: just for testing purpose
  {
    path: `${RouterCommonPagesEnum.ContentPlayerTestPage}/task/:taskName/items/:itemsName`,
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/content-player-test-page/content-player-test-page.component').then(
        (m) => m.ContentPlayerTestPageComponent
      ),
  },
  {
    path: `${RouterCommonPagesEnum.ExampleSum}/:id`,
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/example-task/example-task.component').then((m) => m.ExampleSumComponent),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: RekensprintRouterEnum.TaskResult,
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/task-result/task-result.component').then((m) => m.TaskResultComponent),
    resolve: {
      taskResult: taskResultResolver,
    },
  },
  {
    path: RouterCommonPagesEnum.Settings,
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/settings/settings.component').then((m) => m.SettingsComponent),
  },
  // {
  //   path: RouterCommonPagesEnum.UserActivity,
  //   pathMatch: 'full',
  //   loadComponent: () =>
  //     import('./pages/user-activity/user-activity.component').then((m) => m.UserActivityComponent),
  // },
  {
    path: RouterAuthEnum.Callback,
    redirectTo: '',
  },
  {
    path: RouterAuthEnum.LoggedOut,
    loadComponent: () =>
      import('./pages/auth/loggedout/loggedout.component').then((m) => m.LoggedoutComponent),
  },
  {
    path: RouterAuthEnum.Forbidden,
    loadComponent: () =>
      import('./pages/auth/forbidden/forbidden.component').then((m) => m.ForbiddenComponent),
  },
];
